import {
  ODataHeader,
  ODataString,
  ODataBoolean,
  ODataDate,
  ODataInteger,
  ODataDecimal,
  HeaderAlignment,
} from "pbas-vue-components";
import {
  translate
} from '../trans'
import store from '@/store'
import { translate2 } from '../trans2'
import { i18n } from '@/plugins/i18n';

export default [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: false,
    visible: true,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
    version: 6,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.Actions",
    type: new ODataString("PendingImportId"),
    sortable: false,
    visible: true,
    searchable: false,
    allowVisibilityChange: false,
    version: 4,
  }),
  new ODataHeader({
    type: new ODataBoolean("Errors"),
    sortable: false,
    visible: true,
    searchable: false,
    allowVisibilityChange: false,
    version: 4
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.IsValid",
    type: new ODataBoolean("IsValid", {
      getHtml: (item, type) => {
        return "<v-icon v-bind='attrs' v-on='on'>error</v-icon>";
      }
    }),
    sortable: false,
    visible: true,
    searchable: false,
    allowVisibilityChange: false,
    version: 3
  }),
  // new ODataHeader({
  //   title: "headers.pendinghourreports.Errors",
  //   type: new ODataString("Errors"),
  //   sortable: false,
  //   visible: false,
  //   searchable: false,
  //   allowVisibilityChange: false,
  //   version: 3
  // }),
  new ODataHeader({
    title: "headers.pendinghourreports.EmployerId",
    type: new ODataString("EmployerId"),
    sortable: false,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.StoreId",
    type: new ODataString("StoreId"),
    sortable: false,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.MemberIdentityId",
    type: new ODataString("MemberIdentityId"),
    sortable: false,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.FrequencyId",
    type: new ODataString("FrequencyId"),
    sortable: false,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.TermId",
    type: new ODataString("TermId"),
    sortable: false,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.GenderId",
    type: new ODataString("GenderId"),
    sortable: false,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.EmploymentTypeId",
    type: new ODataString("EmploymentTypeId"),
    sortable: false,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.MemberCertificate",
    type: new ODataString("MemberCertificate"),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.SIN",
    type: new ODataString("SIN"),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.FirstName",
    type: new ODataString("FirstName"),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.LastName",
    type: new ODataString("LastName"),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.Gender",
    type: new ODataString("Gender"),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.DateOfBirth",
    type: new ODataDate("DateOfBirth"),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.Employer",
    type: new ODataString("Employer"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.EmployeeNumber",
    type: new ODataString("EmployeeNumber"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.Store",
    type: new ODataString("Store"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.Frequency",
    type: new ODataString("Frequency"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.EmploymentType",
    type: new ODataString("EmploymentType"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.HireDate",
    type: new ODataDate("HireDate"),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.Earnings",
    type: new ODataDecimal("Earnings"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.TermName",
    type: new ODataString("TermName"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.TermYear",
    type: new ODataString("TermYear"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    type: new ODataDate("StartDate"),
    sortable: false,
    visible: false,
    searchable: false,
    allowVisibilityChange: false
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.TerminationDate",
    type: new ODataDate("TerminationDate"),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.TerminationReason",
    type: new ODataString("TerminationReason"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.Amount",
    type: new ODataDecimal("Amount"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.IsNew",
    type: new ODataBoolean("IsNew"),
    sortable: false,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.ContributionAmount",
    type: new ODataDecimal("ContributionAmount"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.EmployerRate",
    type: new ODataDecimal("EmployerRate"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.ExpectedContribution",
    type: new ODataDecimal("ExpectedContribution"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.pendinghourreports.ContributionDiff",
    type: new ODataDecimal("ContributionDiff"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  
];
